// Corporate Color Palette
export const colors = {
  // Primary Corporate Blue
  primary: {
    main: '#012169',    // PMS 280 C
    light: '#418FDE',   // PMS 279 C
    dark: '#0D5257',    // PMS 7476 C
  },
  
  // Secondary Blues
  secondary: {
    main: '#00A9E0',    // PMS 2995 C
    light: '#41B6E6',   // PMS 298 C
    medium: '#62B5E5',  // PMS 2915 C
    dark: '#007DBA',    // PMS 7461 C
  },
  
  // Success/Green Palette
  success: {
    main: '#50A684',    // PMS 7723 C
    light: '#6BCABA',   // PMS 570 C
    bright: '#A4D65E',  // PMS 367 C
    medium: '#6CC24A',  // PMS 360 C
    dark: '#286140',    // PMS 7734 C
    teal: '#00857D',    // PMS 7717 C
    mint: '#00B398',    // PMS 3275 C
    pale: '#B1E4E3',    // PMS 317 C
  },
  
  // Warning/Yellow Palette
  warning: {
    main: '#CFB023',    // PMS 7752 C
    bright: '#FFD100',  // PMS 109 C
    pale: '#F1EB9C',    // PMS 600 C
  },
  
  // Error/Red Palette
  error: {
    main: '#8A1538',    // PMS 1955 C
    light: '#CD545B',   // PMS 7418 C
    dark: '#9D2235',    // PMS 201 C
  },
  
  // Neutral/Grey Palette
  neutral: {
    lightest: '#BCC9C5', // PMS 5527 C
    lighter: '#A6BBC8',  // PMS 5435 C
    light: '#9BCBEB',    // PMS 291 C
    medium: '#9EA2A2',   // PMS 422 C
    dark: '#768692',     // PMS 7544 C
    darkest: '#4B4F54',  // PMS 7540 C
  },
} as const;